import { Garantias } from "components/Garantias/Garantias/Garantias";
// import { Terrenos, VehiculosGarantia, CasasGarantia, Prendas } from "components/Garantias";

const routesGarantias = [
  {
    path: "/garantias-catalogo",
    name: "Garantías",
    icon: "nc-icon nc-single-copy-04",
    component: <Garantias />,
    permissions: ['GARANTIAS', 'ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  // {
  //   path: "/vehiculos-garantia",
  //   name: "Vehiculos Garantia",
  //   icon: "nc-icon nc-bank",
  //   component: <VehiculosGarantia />,
  //   permissions: ['GARANTIAS', '49_ADMIN'],
  //   layout: "/app",
  //   subRoutes: [],
  // },
  // {
  //   path: "/casas-garantia",
  //   name: "Casas Garantia",
  //   icon: "nc-icon nc-bank",
  //   component: <CasasGarantia />,
  //   permissions: ['GARANTIAS', '49_ADMIN'],
  //   layout: "/app",
  //   subRoutes: [],
  // },
  // {
  //   path: "/prendas",
  //   name: "Prendas",
  //   icon: "nc-icon nc-bank",
  //   component: <Prendas />,
  //   permissions: ['GARANTIAS', '49_ADMIN'],
  //   layout: "/app",
  //   subRoutes: [],
  // },
]

export {
    routesGarantias
}